import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Collapse, ButtonGroup, Button } from 'reactstrap'
import 'font-awesome/css/font-awesome.min.css'
import { FormattedMessage, injectIntl } from 'react-intl'

import logoWhiteSmall from '../images/dg_logo_white_small.png'
import InputNumber from './InputNumber'


class SequenceForm extends Component {

  state = { showMenu: false }

  handleGameInfoChange = (e) => { this.props.onGameInfoChange(!e.currentTarget.classList.contains('active')) }
  toogleMenu = () => { this.setState((prevState, props) => ({ showMenu: !prevState.showMenu })) }
  handleRealtimeChange = (e) => { this.props.onRealtimeChange(!e.currentTarget.classList.contains('active')) }
  handlePlayChange = (e) => { this.props.onPlayChange(!e.currentTarget.classList.contains('active')) }
  handleMetronomeChange = (e) => { this.props.onMetronomeChange(!e.currentTarget.classList.contains('active')) }
  handleSoundChange = (e) => { this.props.onSoundChange(!e.currentTarget.classList.contains('active')) }
  handleNBarsChange = (value) => { this.props.onNBarsChange(value) }
  handleBarRepsChange = (value) => { this.props.onBarRepsChange(value) }
  handleBpmChange = (value) => { this.props.onBpmChange(value) }
  handleNewSequence = (e) => { this.props.onNewSequence() }
  handleBasesSupsSubsChange = (e) => { this.props.onBasesSupsSubsChange(e.target.dataset.type, e.target.dataset.value) }

  render() {

    const {
      intl,
      gameInfo,
      play,
      metronome,
      sound,
      realtime,
      nBars,
      barReps,
      bpm,
      bases,
      basesSel,
      sups,
      supsSel,
      subs,
      subsSel
    } = this.props
    const { showMenu } = this.state

    return (
      <div id="sequence-form">
        <div id="form-headers" className="dfr-nw">
          <Link to='/'>
            <Button color="primary" aria-label="Back">
              <i className="fa fa-fw fa-chevron-left"></i>
              <span className="button-tag">
                <FormattedMessage id="form.back"/>
              </span>
            </Button>
          </Link>
          <div id="header-logo" className="f-sep"><img src={logoWhiteSmall} alt="DrummerGames White Logo"/></div>
          <Button id="gameinfo" color="primary" active={gameInfo} onClick={this.handleGameInfoChange} aria-label="Game information">
            <i className="fa fa-fw fa-info"></i>
            <span className="button-tag">
              <FormattedMessage id="form.info"/>
            </span>
          </Button>&nbsp;
          <Button color="primary" onClick={this.toogleMenu} aria-label="Game options menu toogler">
            <i className="fa fa-fw fa-bars"></i>
            <span className="button-tag">
              <FormattedMessage id="form.options"/>
            </span>
          </Button>
        </div>
        <Collapse isOpen={showMenu}>
          <form>
            <div id="form-genbuttons" className="dfr-nw" role="toolbar" aria-label="Toolbar with general buttons">
              <Button id="playstop" color="primary" active={play} onClick={this.handlePlayChange} aria-label="Play and Stop">
                <i className={play ? "fa fa-stop" : "fa fa-play"}></i>
                <span className="button-tag">
                  <FormattedMessage id={play ? "form.stop" : "form.play"}/>
                </span>
              </Button>{' '}
              <Button id="metronomebtn" color="primary" active={metronome} onClick={this.handleMetronomeChange} aria-label="Metronome show and hide">
                <i className={metronome ? "fa fa-heartbeat" : "fa fa-heart"}></i>
                <span className="button-tag">
                  <FormattedMessage id="form.metronome"/>
                </span>
              </Button>{' '}
              <Button id="sound" color="primary" active={sound} onClick={this.handleSoundChange} aria-label="Sound on and off">
                <i className={sound ? "fa fa-bell" : "fa fa-bell-slash"}></i>
                <span className="button-tag">
                  <FormattedMessage id="form.sound"/>
                </span>
              </Button>{' '}
              <Button id="refresh" color="primary" onClick={this.handleNewSequence} aria-label="New Sequence">
                <i className="fa fa-refresh"></i>
                <span className="button-tag">
                  <FormattedMessage id="form.newSequence"/>
                </span>
              </Button>{' '}
              <div className="f-sep"></div>
              <Button id="realtime" color="primary" active={realtime} onClick={this.handleRealtimeChange} aria-label="Realtime mode">
                <FormattedMessage id="form.realtime"/>
              </Button>
            </div>
            <div id="form-geninputs" className="dfr-nw" role="toolbar" aria-label="Toolbar with general inputs">
              {!realtime &&
                <InputNumber className="geninput"
                  tag={intl.messages['form.bars']}
                  min={1}
                  max={32}
                  nValue={nBars}
                  onNumberChange={this.handleNBarsChange}
                />                            
              }
              <InputNumber className="geninput"
                tag={intl.messages['form.barReps']}
                min={1}
                max={16}
                nValue={barReps}
                onNumberChange={this.handleBarRepsChange}
              />              
              <div className="f-sep"></div>
              <InputNumber className="geninput"
                tag={intl.messages['form.bpm']}
                min={1}
                max={300}
                nValue={bpm}
                onNumberChange={this.handleBpmChange}
              />
            </div>
            <div id="form-basesupsub" className="dfr-w" role="toolbar" aria-label="Toolbar with base, superindex and subindex inputs">
              {Object.keys(bases.options).length > 0 && bases.showSelector &&
                <div className="bgroup">
                  <div>{bases.tag[intl.locale]}</div>
                  <ButtonGroup className="dfr-w f-ais">
                    { Object.keys(bases.options).map((v) => 
                        <Button
                          color="primary"
                          active={basesSel.includes(bases.options[v])}
                          onClick={this.handleBasesSupsSubsChange}
                          data-type="basesSel"
                          data-value={bases.options[v]}
                          key={'base'+bases.options[v]}
                        >
                          {v}
                        </Button>) }
                  </ButtonGroup>
                </div>
              }
              {Object.keys(sups.options).length > 0 && sups.showSelector &&
                <div className="bgroup">
                  <div>{sups.tag[intl.locale]}</div>
                  <ButtonGroup className="dfr-w f-ais">
                    { Object.keys(sups.options).map((v) => 
                        <Button
                          color="primary"
                          active={supsSel.includes(sups.options[v])}
                          onClick={this.handleBasesSupsSubsChange}
                          data-type="supsSel"
                          data-value={sups.options[v]}
                          key={'sup'+sups.options[v]}
                        >
                          {v}
                        </Button>) }
                  </ButtonGroup>
                </div>
              }
              {Object.keys(subs.options).length > 0 && subs.showSelector &&
                <div className="bgroup">
                  <div>{subs.tag[intl.locale]}</div>
                  <ButtonGroup className="dfr-w f-ais">
                    { Object.keys(subs.options).map((v) => 
                        <Button
                          color="primary"
                          active={subsSel.includes(subs.options[v])}
                          onClick={this.handleBasesSupsSubsChange}
                          data-type="subsSel"
                          data-value={subs.options[v]}
                          key={'sub'+subs.options[v]}
                        >
                          {v}
                        </Button>) }
                  </ButtonGroup>
                </div>
              }
            </div>
          </form>
        </Collapse>
      </div>
    )
  }
}

SequenceForm.propTypes = {
  bases: PropTypes.object,
  sups: PropTypes.object,
  subs: PropTypes.object,
  gameInfo: PropTypes.bool,
  realtime: PropTypes.bool,
  play: PropTypes.bool,
  metronome: PropTypes.bool,
  sound: PropTypes.bool,
  nBars: PropTypes.number,
  barReps: PropTypes.number,
  bpm: PropTypes.number,
  basesSel: PropTypes.array.isRequired,
  supsSel: PropTypes.array,
  subsSel: PropTypes.array
}

SequenceForm.defaultProps = {
  bases: { options: [0], tag: 'Bases' },
  sups: { options: [], tag: 'Superindexes' },
  subs: { options: [], tag: 'Subindexes' },
  gameInfo: false,
  realtime: false,
  play: true,
  metronome: true,
  sound: false,
  nBars: 1,
  barReps: 1,
  bpm: 80,
  basesSel: [0],
  supsSel: [],
  subsSel: []
}

export default injectIntl(SequenceForm)


// WEBPACK FOOTER //
// ./src/components/SequenceForm.js